import { dynamicAssets } from 'js/constants/Paths';

export const parseAboutData = (data) => {
  const { header: { image = '' } = {} } = data;
  image !== '' && (data.header.image = dynamicAssets(image));

  return { ...data };
};
